module.exports = __webpack_public_path__ + "static/media/nima_vaziri.72388318.png";